import React, { useState, useEffect } from "react";
import { AuditingTable } from "components/auditing";
import { UserAccess } from "components/user-access";
import { PageRestricted } from "pages/errors/page-restricted";
import { LicenceCheckingService } from "services/LicenceCheckingService";
import { UserService } from "services/UserService";
import { Tabs } from 'components/navigation';

export function LicenceCheckingHistory(props) {


    const requiredAction = "LicenceChecking:Manage";
    const [loading, setLoading] = useState(true);
    const noDataMessage = "No changes have been made for the selected date period";
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);
    const [tabTitle, setTabTitle] = useState("Alerts");
    const [tabSettings, setTabSettings] = useState([
        { key: "ALERTS", title: "Alerts", selected: true },
        { key: "POLICIES", title: "Policies", selected: false },
        { key: "SETTINGS", title: "Settings", selected: false },
        { key: "USERS", title: "Users", selected: false },
    ]);

    useEffect(() => {
        if (tabTitle) {
            //This should force the Auditing table to re-run onTableChange

            setLoading(true);
            setTableData([]);
            setTableRecordCount(0);
        }
    }, [tabTitle]);

    function tableChanged(changeLogResponse) {
        setTableData(changeLogResponse.data);
        setTableRecordCount(changeLogResponse.totalCount);

        setLoading(false);
    }

    function onTableChange(pageSize, pageNumber, startDate, endDate) {
        setLoading(true);
        if (tabTitle === "Users") {
            UserService.getLicenceCheckingChangeLog(pageSize, pageNumber, startDate, endDate).then(r => {
                tableChanged(r);
            });
        } else {
            LicenceCheckingService.getChangeLog(tabTitle, pageSize, pageNumber, startDate, endDate).then(r => {
                tableChanged(r);
            });
        }
    }

    function onTabClick(tabIndex) {
        setTabSettings((prev) => {
            setTabTitle(prev[tabIndex].title);
            return prev.map(function (c, index) {
                return {
                    ...c,
                    selected: index === tabIndex
                }
            })
        });
    }

    return (
        <UserAccess perform={requiredAction}
            yes={() => (
                <>
                    <div className="row">
                        <h2>History</h2>
                        <div className="spacer-bottom">
                        <Tabs tabs={tabSettings} onClick={onTabClick} disabled={loading} />
                        </div>
                    </div>
                    <AuditingTable hideHeader key={tabTitle} data={tableData} totalCount={tableRecordCount} onChange={onTableChange} noDataMessage={noDataMessage} loading={loading}></AuditingTable>
                    
                </>
            )}
            no={() => (
                <div className="row">
                    <PageRestricted />
                </div>
            )}
        />
    );
}